import { withTranslation } from "react-i18next";
import { compose } from "redux";
import { useIntl } from "react-intl";
import { Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import classNames from "classnames";
import { Controller, useFormContext } from "react-hook-form";
import Select from "react-select";
import { ErrorMessage } from "@hookform/error-message";
import { Card, CardBody } from "../../../../_metronic/_partials/controls";

import "react-datepicker/dist/react-datepicker.css";

const SearchFilters = ({ revenueTypes, resetFilters, statusFilterList }) => {
  const intl = useIntl();
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext({ reValidateMode: "onChange" });

  return (
    <div className="bg-white rounded-fix">
      <div className="px-4 py-6">
        <h3 className="page-heading-text gap-1 mb-0">
          Search
          <OverlayTrigger
            overlay={
              <Tooltip id="search-transaction-tooltip">
                Use one or more filters above to refine your search results. You
                can combine multiple criteria for more accurate results.
              </Tooltip>
            }>
            <span className="tooltip-wrapper">
              <i className="fa fa-question-circle" />
            </span>
          </OverlayTrigger>
        </h3>
      </div>
      <div className="px-4 py-6 pt-0">
        <Row className="justify-content-md-center">
          <Col md={12}>
            <Row className="form-group gap-5 gap-md-0 mb-5">
              <Col md={4}>
                <Form.Control
                  name="search"
                  placeholder="Search by Investor"
                  className={classNames("form-control common-search-input")}
                  {...register("search")}
                />
              </Col>
              <Col md={4}>
                <Controller
                  name="revenueType"
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      classNamePrefix="filter-select"
                      placeholder={"Search by Revenue Type"}
                      options={revenueTypes}
                      value={revenueTypes.find(
                        (option) => option.value === field.value || null
                      )}
                      onChange={(selected) =>
                        field.onChange(selected ? selected.value : null)
                      }
                    />
                  )}
                />
              </Col>
              <Col md={4}>
                <Form.Control
                  name="transactionNumber"
                  placeholder="Search by Transaction ID"
                  className={classNames("form-control common-search-input")}
                  {...register("transactionNumber")}
                />
              </Col>
            </Row>
            <Row className="form-group gap-5 gap-md-0 mb-5">
              <Col md={4}>
                <Form.Control
                  type="number"
                  name="minAmount"
                  placeholder="Search by Min Amount"
                  className={classNames("form-control common-search-input", {
                    "is-invalid": errors.minAmount,
                  })}
                  {...register("minAmount", {
                    pattern: {
                      value: /[0-9]/,
                      message: "Minimum amount should be positive number",
                    },
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name="minAmount"
                  render={({ message }) => (
                    <div className="invalid-feedback">{message}</div>
                  )}
                />
              </Col>
              <Col md={4}>
                <Form.Control
                  type="number"
                  name="maxAmount"
                  placeholder="Search by Max Amount"
                  className={classNames("form-control common-search-input", {
                    "is-invalid": errors.maxAmount,
                  })}
                  {...register("maxAmount", {
                    pattern: {
                      value: /[0-9]/,
                      message: "Maximum amount should be positive number",
                    },
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name="maxAmount"
                  render={({ message }) => (
                    <div className="invalid-feedback">{message}</div>
                  )}
                />
              </Col>
              <Col md={4}>
                <Controller
                  name="status"
                  control={control}
                  render={({ field: { value, onChange } }) => (
                    <Select
                      inputId="searchFilterStatus"
                      classNamePrefix="filter-select"
                      placeholder={intl.formatMessage({
                        id: "transaction.search.status",
                      })}
                      options={statusFilterList}
                      value={statusFilterList.find(
                        (option) => option.value === value || null
                      )}
                      onChange={(selected) =>
                        onChange(selected ? selected.value : null)
                      }
                    />
                  )}
                />
              </Col>
            </Row>
            <div className="form-group gap-2 d-flex">
              <div>
                <button className="common-search-btn search-reset-btn">
                  Search
                </button>
              </div>
              <div>
                <button
                  className="btn text-black py-2 search-reset-btn ms-3 font-size-sm fw-medium bg-select-bg-clr"
                  type="button"
                  onClick={resetFilters}>
                  Reset
                </button>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};
export default compose(withTranslation())(SearchFilters);
